import checkSign from "../../../../src/icons/checkSign.svg";

type Props = {
    isSelected?: boolean,
    size?: number,
}

export const FiltersCheckBox: React.FC<Props> = ({ isSelected, size=24 }) => {
    return (
        <div
            id="filters-checkbox"
            className={`
                flex
                items-center
                justify-center
                transition-background  
                duration-200
                `}
            style={{ 
                border: "1px solid",
                 borderColor: "#DBE1EB",
                 borderRadius: "4px", 
                 height: `${size}px`,
                 width: `${size}px`,
                 ...(isSelected ? { background: "#269C6E", borderColor: "#269C6E" } : {}) }}
        >
            <img 
                className="transition-opacity duration-200"
                style={{ width: `${0.75 * size}px`, opacity: isSelected ? "1" : "0", }}
                src={checkSign} alt="" />
        </div>
    )
}
